import { render } from "./setup-profile.vue?vue&type=template&id=54c6011d&scoped=true"
import script from "./setup-profile.vue?vue&type=script&lang=js"
export * from "./setup-profile.vue?vue&type=script&lang=js"

import "./setup-profile.vue?vue&type=style&index=0&id=54c6011d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c6011d"]])

export default __exports__